export default "__VITE_ASSET__f26lO50Z__"